const initialState = () => ({
  notifications: null,
  notificationsData: [],
  limitedNotifications: [],
});

const state = initialState();

export default state;
